import { EyeIcon } from "@heroicons/react/outline";
import { IAttendantTemplateData, IAttendantTemplateItem, ISimpleEventDetail } from "interfaces";
import { get } from "lodash"
import { Fragment, useState } from "react";
import moment from "moment";
import { Fields } from "../fields";
import { useTranslation } from "@refinedev/core";

interface IGroupFormProps {
  templateData: IAttendantTemplateItem;
  eventDetailData: ISimpleEventDetail;
}

const INITIAL_FIELD_MODAL_CONFIG = {
  open: false,
  index: -1,
}
export const Groups = ({templateData, eventDetailData}: IGroupFormProps) => {
  const { translate } = useTranslation();
  const [fieldModalConfig, setFieldModalConfig] = useState(INITIAL_FIELD_MODAL_CONFIG)

  const groupsData = templateData.data ?? [];

  const isOpenRegistration = get(eventDetailData, "open_registration_date", "") 
    ? moment().utc().isAfter(moment(eventDetailData.open_registration_date).utc())
    : false;
  
  const _onCloseModal = () => {
    setFieldModalConfig(INITIAL_FIELD_MODAL_CONFIG);
  }

  return (
    <div className="px-4 py-4 sm:px-6">
      <div className="mb-4 sm:flex sm:items-center sm:justify-between">
        <p>{translate("eventSetup.participantTemplate.groups")}</p>
        <p>{translate("eventSetup.participantTemplate.templateId")}: {templateData.id}</p>
      </div>
      <div className="grid sm:grid-cols-6 lg:gap-x-6">
        <div
          className="col-span-full"
        >
          {groupsData.map((field: IAttendantTemplateData, index: number) => (
            <div
              className="border rounded-lg mb-4 border-gray-300"
              key={index}
            >
              <div className={`box-container p-0`}>
                <div
                  className="flex flex-wrap justify-between items-center px-4 py-4 sm:px-6 hover:cursor-pointer"
                  onClick={() => setFieldModalConfig({
                    index: index,
                    open: true,
                  })}
                >
                  <div className="flex flex-row flex-wrap items-center gap-x-3 shrink-0">
                    {eventDetailData.languages.map((lang, langIndex) => (
                      <Fragment key={lang}>
                        {langIndex !== 0 ? <span>•</span> : <></>}
                        <p className="text-sm" style={{wordBreak: "break-word"}}>
                          {get(field.group, `label.${lang}`, "")}
                        </p>
                      </Fragment>
                    ))}
                  </div>
                  <div className="flex flex-row gap-x-2">
                    <p className="text-sm">{`${groupsData[index].fields.length} ${translate("eventSetup.participantTemplate.fields")}`}</p>
                    <EyeIcon className="w-5 h-5" />
                  </div>
                </div>
              </div>
            </div>
          ))}
          <Fields
            isOpenRegistration={isOpenRegistration}
            groupData={groupsData[fieldModalConfig.index] ?? []}
            languages={eventDetailData.languages ?? []}
            open={fieldModalConfig.open}
            onClose={_onCloseModal}
          />
        </div>
      </div>
    </div>
  )
}